import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  FormLabel,
  Heading,
  Icon,
  Input,
  Radio,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { closeAddSubjectAdmin, openShowSubjectAdminDataModel } from "../../../../modules/admin-modules/models/Actions";
import MainModel from "../../../../components/Models/main-model";
import { useForm } from "react-hook-form";
import MainInput from "../../../../components/Form/input";
import {
  createAdminSubjectRequest,
  editTeacherRequest,
} from "../../../../modules/admin-modules/teachers/Actions";
import { getAllGradesRequest } from "../../../../modules/admin-modules/grades/Actions";
import { getAllSubjectsRequest } from "../../../../modules/admin-modules/subjects/Actions";

const AddSubjectAdmin = ({ isAdd, data, setSelectedData, setAddedSubjectAdmin }) => {
  const openTeacher = useSelector((state) => state.model.isOpen36);
  const dispatch = useDispatch();
  const subjects = useSelector((state) => state.subjects.subjects);
  const grades = useSelector((state) => state.grades.grades);
  const isLoading = useSelector((state) => state.teachers.isLoading);
  const [selectedLogo, setSelectedLogo] = useState("");

  const gradesOptions = grades?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const subjectsOptions = subjects?.map((data) => {
    return { value: data.id, label: data.name };
  });

  useEffect(() => {
    if (openTeacher) {
      dispatch(getAllGradesRequest());
      dispatch(getAllSubjectsRequest());
    }
  }, [openTeacher]);
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: data ? data : {},
    shouldUnregister: true,
  });

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة مادة" : "تعديل  مادة"}
      </Heading>
    </Box>
  );
  const onSubmit = (data) => {
    const action = (responseData) => {
      dispatch(closeAddSubjectAdmin());
      setAddedSubjectAdmin && setAddedSubjectAdmin(responseData);
      dispatch(openShowSubjectAdminDataModel());
      setSelectedData({});
      setSelectedLogo("");
      reset();
    };
    if (isAdd) {
      let formData = new FormData();
      for (let key in data) {
        formData.append(key, data[key]);
      }
      dispatch(createAdminSubjectRequest(formData, action));
    } else {
      let formData = new FormData();
      for (let key in data) {
        formData.append(key, data[key]);
      }
      dispatch(
        editTeacherRequest({
          id: data?.id,
          formData: formData,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeAddSubjectAdmin());
    setSelectedData({});
    setSelectedLogo("");
    reset();
  };
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openTeacher}
      buttonTitle={isAdd ? " إضافة مادة" : "تعديل  مادة"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={5} dir="rtl" w="100%">
          <Box w="55%">
            <MainInput
              label="اسم المادة"
              error={errors?.subject_name?.message}
              placeholder="ادخل اسم المادة"
              register={register}
              name="subject_name"
            />
          </Box>
          <Box w="55%">
            <MainInput
              label="اسم المادة بالعربية"
              error={errors?.subject_name_ar?.message}
              placeholder="ادخل اسم المادة بالعربية"
              register={register}
              name="subject_name_ar"
            />
          </Box>
          <Box w="55%">
            <MainInput
              label="رقم الموبايل"
              error={errors?.phone?.message}
              placeholder="اكتب رقم الموبايل"
              register={register}
              name="phone"
            />
          </Box>
          <Box w="55%">
            <FormLabel>الصف : </FormLabel>
            <Select
              options={gradesOptions}
              onChange={(data) => setValue("grade_id", data.value)}
              styles={colourStyles}
              placeholder="الصف"
            />
          </Box>
          <Box w="55%">
            <FormLabel>الشعار</FormLabel>
            <Button
              bg="main_1"
              color="white"
              borderRadius="8px"
              textAlign="center"
              position="relative"
              w="100%"
            >
              <Text>{selectedLogo ? selectedLogo : "اختر صورة الشعار"}</Text>
              <Input
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    setValue("logo", file);
                    setSelectedLogo(file.name);
                  }
                }}
                type="file"
                accept="image/*"
                placeholder="اختر صورة الشعار"
                opacity="0"
                position="absolute"
                w="100%"
                h="100%"
              />
            </Button>
          </Box>
        </Stack>
      </form>
    </MainModel>
  );
};

export default AddSubjectAdmin;
